var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaryDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0635 2.84863H5.06348C4.79826 2.84863 4.54391 2.95399 4.35637 3.14153C4.16883 3.32906 4.06348 3.58342 4.06348 3.84863V19.8486C4.06348 20.1138 4.16883 20.3682 4.35637 20.5557C4.54391 20.7433 4.79826 20.8486 5.06348 20.8486H6.06348V21.8486C6.06348 22.1138 6.16883 22.3682 6.35637 22.5557C6.54391 22.7433 6.79826 22.8486 7.06348 22.8486C7.32869 22.8486 7.58305 22.7433 7.77058 22.5557C7.95812 22.3682 8.06348 22.1138 8.06348 21.8486V20.8486H17.0635C17.8591 20.8486 18.6222 20.5326 19.1848 19.97C19.7474 19.4073 20.0635 18.6443 20.0635 17.8486V5.84863C20.0635 5.05298 19.7474 4.28992 19.1848 3.72731C18.6222 3.1647 17.8591 2.84863 17.0635 2.84863ZM14.0635 18.8486H6.06348V4.84863H14.0635V18.8486ZM18.0635 17.8486C18.0635 18.1138 17.9581 18.3682 17.7706 18.5557C17.583 18.7433 17.3287 18.8486 17.0635 18.8486H16.0635V4.84863H17.0635C17.3287 4.84863 17.583 4.95399 17.7706 5.14153C17.9581 5.32906 18.0635 5.58342 18.0635 5.84863V17.8486Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryDrop);
export default __webpack_public_path__ + "static/media/DiaryDrop.4d3c5b9ca82aa8e75e64406dbd44c446.svg";
export { ForwardRef as ReactComponent };